import { useEffect, useState } from "react";

/**
 *
 * @deprecated use useDebounce from packages/core/src/shared/hooks/useDebounce.ts
 */
const useDebounce = <T>(value: T, delay: number): [T, boolean] => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const [isLoadingDebounce, setIsLoadingDebounce] = useState<boolean>(false);

  useEffect(() => {
    setIsLoadingDebounce(true);
    const timer = setTimeout(() => {
      setIsLoadingDebounce(false);
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return [debouncedValue, isLoadingDebounce];
};

export default useDebounce;
